'use strict';

require('core-js'); // polyfills; should be first
require('ng-idle');
require('angular-gettext');
require('angularjs-slider');
require('ion-md-input');
// need specific time zone build
require('../node_modules/moment-timezone/builds/moment-timezone-with-data-1970-2030.js');
require('./AveoUtility');
require('./DummyIonicMaterial');

var log = require('../../log/Log').channel('Inara');

if (process.env.build === 'debug') {
    log.messageLimit = 0;
    log.info('debug build, no limit on log message length');
} else {
    log.messageLimit = 1000;
    log.info(process.env.build + ' build, limiting log messages to ' +
        log.messageLimit + ' characters');
}

window.addEventListener('error', function(event) {
    var message = 'error: ';

    if (event.error) {
        message += event.error.stack ? event.error.stack : event.error;
    } else {
        message += event.message;
    }

    log.error(message);
    event.preventDefault();
});

window.addEventListener('unhandledrejection', function(event) {
    var message = 'unhandled rejection: ';
    message += event.reason.stack ? event.reason.stack : event.reason;
    log.error(message);
    event.preventDefault();
});

angular.module('inara', ['ionic', 'ionic-material', 'gettext', 
                         'ngIdle', 'ngOrderObjectBy', 'ionMdInput',
                         'aveoUtility', 'rzSlider', 'ngSanitize']);

angular.module('inara').config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(process.env.build === 'debug');        
}]);

angular.module('inara').config(['$provide', function($provide) {
    // Here, we decorate the $log functions to intercept them for our log
    // handler. We have not found out how to trap exceptions before ionic
    // or angular gets them, so we use $log.error as our exception trap.

    $provide.decorator('$log', ['$delegate', function($delegate) {
        $delegate.debug = logHandler(log.debug.bind(log));
        $delegate.log = logHandler(log.info.bind(log));
        $delegate.info = logHandler(log.info.bind(log));
        $delegate.warn = logHandler(log.warning.bind(log));
        $delegate.error = logHandler(log.error.bind(log));

        function logHandler(logFunction) {
            return function() {
                var message = '';

                for (var i = 0; i < arguments.length; i++) {
                    if (typeof arguments[i] === 'object') {
                        if ('message' in arguments[i]) {
                            message += arguments[i].message;
                        }

                        if ('stack' in arguments[i]) {
                            message += '\n' + arguments[i].stack;
                        }
                    } else {
                        message += arguments[i];
                    }
                }

                logFunction(message);
            };
        }

        return $delegate;
    }]);
}]);

angular.module('inara')
.config(['$ionicConfigProvider', function($ionicConfigProvider) {
    // Default behavior for Inara on all platforms (browser and cordova)
    $ionicConfigProvider.backButton.text('');
    $ionicConfigProvider.form.checkbox('circle');
    $ionicConfigProvider.form.toggle('small');
    $ionicConfigProvider.navBar.alignTitle('center');
    $ionicConfigProvider.platform.android.tabs.style('standard');
    $ionicConfigProvider.platform.android.tabs.position('bottom');
    $ionicConfigProvider.spinner.icon('android');
    $ionicConfigProvider.views.forwardCache(true);
    $ionicConfigProvider.views.swipeBackEnabled(false);
    $ionicConfigProvider.views.transition('android');
}])
.config(['TitleProvider', function(TitleProvider) {
    TitleProvider.enabled(false); // disable title provider used by ng-idle
}])
.config(['IdleProvider', function(IdleProvider) {
    // Add touchrepeat to default list of idle interrupting events
    IdleProvider.interrupt(
        'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove touchrepeat scroll'
    );
}]);

angular
    .module('ngOrderObjectBy', [])
    .filter('orderObjectBy', function() {
        return function (items, field, reverse, addKey) {
            var filtered = [];
            angular.forEach(items, function(item, key) {
                if (addKey) {
                    item.$key = key;                    
                }
                filtered.push(item);
            });
            function index(obj, i) {
                return obj[i];
            }
            filtered.sort(function (a, b) {
                var comparator;
                var reducedA = field.split('.').reduce(index, a);
                var reducedB = field.split('.').reduce(index, b);
                if (reducedA === reducedB) {
                    comparator = 0;
                } else {
                    comparator = reducedA > reducedB ? 1 : -1;
                }
                return comparator;
            });
            if (reverse) {
                filtered.reverse();
            }
            return filtered;
        };
    });

angular.module('inara').run(Inara);

require('./AmxBeaconListenerService');
require('./AutomationService');
require('./Router');
require('./OfflineStateSaverService');
require('./StateLoggerService');
require('./ControllerService');
require('./DeviceService');
require('./EquipmentService');
require('./LanguageService');
require('./LedService');
require('./OfflinePopupService');
require('./RoomPasswordService');
require('./SleepService');
require('./ViewStateService');

Inara.$inject = ['StateLoggerService', 'ViewStateService',
                 'EquipmentService', '$injector', 'gettextCatalog',
                 '$ionicPlatform' ];

var envInject = {
    browser: [ 'AutomationService', 'OfflinePopupService', 'RoomPasswordService' ],
    cordova: [ 'AmxBeaconListenerService', 'AutomationService', 'ControllerService',
        'DeviceService', 'LedService', 'OfflineStateSaverService', 'SleepService',
        'RoomPasswordService' ],
};

function Inara(StateLoggerService, ViewStateService,
               EquipmentService, $injector, gettextCatalog, $ionicPlatform) {
    log.info('running');

    if (process.env.build === 'debug') {
        gettextCatalog.debug = true;
    } else {
        gettextCatalog.debug = false;
    }

    // disable the Android back button
    $ionicPlatform.registerBackButtonAction(function (event) {
        event.preventDefault();
    }, 100);

    if (envInject.hasOwnProperty(process.env.appEnv)) {
        log.info(process.env.appEnv + ' environment detected');

        var injects = envInject[process.env.appEnv];

        for (var i = 0; i < injects.length; i++) {
            $injector.get(injects[i]);
        }
    } else {
        log.error('unknown environment detected: ' + process.env.appEnv);
    }
}

if (ionic &&
    ionic.views &&
    typeof ionic.views.Toggle === 'function' &&
    typeof ionic.views.Toggle.prototype.dragStart === 'function') {
    log.info('monkey-patching ionic.views.Toggle.dragStart()');
    ionic.views.Toggle.prototype.dragStart = function(e) {
        if (this.checkbox.disabled) return;

        // Patched to use Element.getBoundingClientRect() instead of Element.offsetXXX
        //
        // Original:
        //  this._dragInfo = {
        //    width: this.el.offsetWidth,
        //    left: this.el.offsetLeft,
        //    right: this.el.offsetLeft + this.el.offsetWidth,
        //    triggerX: this.el.offsetWidth / 2,
        //    initialState: this.checkbox.checked
        //  };
        //
        // Previously, the code would fail to allow dragging a toggle to the right
        // when the toggle is inside of much larger container element(s).  The
        // offsetXXX dimensions are relative to the immediate parent element while
        // the gesture coordinates compared elsewhere in the toggle are relative to 
        // the screen.
        //
        // Additionally, rather than using the base element, we get the bounds of
        // the track element since we may inflate the size of the base element
        // with padding to accomodate dragging farther from the right inside 
        // list items.
        //
        // Lastly, the triggerX bounds are set to a smaller value to ensure easy
        // triggering when sliding.

        var bounds = this.track.getBoundingClientRect();
        this._dragInfo = {
            width: bounds.width,
            left: bounds.left,
            right: bounds.left + bounds.width,
            triggerX: bounds.width / 4,
            initialState: this.checkbox.checked
        };

        // Stop any parent dragging
        e.gesture.srcEvent.preventDefault();

        // Trigger hold styles
        this.hold(e);
    };

}
else {
    log.warning('ionic.views.Toggle may be of the wrong type for patching!');
}
